import React from 'react'
import { connect } from 'react-redux'

import { postNode } from '../controllers/treeEngine'
import { startTextEdit, moveCursorTo } from '../store/cursor'
import { generateUID } from '../utils/generateUID'

const PlusButtonComponent = ({ nodeIdBeforeButton, startTextEdit, moveCursorTo }) => {
    const onClick = () => {
        const node = {}
        if (nodeIdBeforeButton) {
            node.previousSiblingId = nodeIdBeforeButton
        }
        node.id = generateUID()

        postNode(node)
        moveCursorTo(node.id)
        startTextEdit()
    }

    return (
        <div className="plus-button-container">
            <button onClick={onClick} className="plus-button">
                <i className="fal fa-plus" />
            </button>
        </div>
    )
}

const mapDispatchToProps = {
    startTextEdit,
    moveCursorTo
}

export const PlusButton = connect(undefined, mapDispatchToProps)(PlusButtonComponent)
